import type { EventType, EventStatus } from '../types';

interface Props {
  type: EventType;
  status?: EventStatus;
  size?: 'sm' | 'md' | 'lg';
}

const typeLabels: Record<EventType, string> = {
  practice: 'Practice',
  regatta: 'Regatta',
  competition: 'Competition',
};

const typeColors: Record<EventType, string> = {
  practice: 'bg-practice/10 text-practice dark:bg-practice/20 dark:text-practice-light',
  regatta: 'bg-regatta/10 text-regatta dark:bg-regatta/20 dark:text-regatta-light',
  competition: 'bg-competition/10 text-competition dark:bg-competition/20 dark:text-competition-light',
};

const sizes: Record<string, string> = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
  lg: 'text-base px-3 py-1.5',
};

export default function EventBadge({ type, status, size = 'md' }: Props) {
  if (status === 'cancelled') {
    return (
      <span className={`inline-flex items-center font-semibold rounded-full bg-cancelled/10 text-cancelled dark:bg-cancelled/20 dark:text-cancelled-light ${sizes[size]}`}>
        Cancelled
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center font-semibold rounded-full ${typeColors[type]} ${sizes[size]}`}>
      {typeLabels[type]}
    </span>
  );
}
